import { useParams } from 'react-router-dom';
import Menu from '../Menu/Menu';
import './SingleCar.scss';
import { useEffect, useState } from 'react';
import api from '../../js/api';

export default function SingleCar() {
    const params = useParams();
    const [data, setData] = useState(null);

    useEffect(() => {
        const cached_data = localStorage.getItem('vehicles');
        if (cached_data) {
            setData(JSON.parse(cached_data)[params.carId]);
        } else {
            const fetch_ = async () => {
                try {
                    const response = await api.get(`/vehicles/${params.carId}`);
                    setData(response);
                } catch (error) {
                    console.error(error);
                }
            }
            fetch_();
        }
    }, []);
    // useEffect(() => {
    //     const cached_data = localStorage.getItem('vehicles');
    //     if (cached_data) 
    //         setData(JSON.parse(cached_data));
    //     else {
    //         const fetch_ = async () => {
    //             try {
    //                 const response = await api.get(`vehicles`);
    //                 localStorage.setItem('vehicles', JSON.stringify(response));
    //                 setData(response);
    //             } catch (error) {
    //                 console.error(error);
    //             }
    //         }
    //         fetch_();
    //     }
    // }, []);

    const print_data = (data = {}, field = '') => {
        return (
            <div className='car-data-container'>
                <h3 className='car-data-title title'>{field.charAt(0).toUpperCase() + field.slice(1)}</h3>
                <div className='car-data'>
                    {
                        (data[field] && typeof (data[field]) === 'object') ? (
                            typeof (data[field][Object.keys(data[field])[0]]) === 'object' ? (
                                Object.keys(data[field]).map((key, index) => (
                                    <div key={index}>
                                        <h4>{key.charAt(0).toUpperCase() + key.slice(1)}</h4>
                                        {
                                            Object.keys(data[field][key]).map((key2, index2) => (
                                                <p key={index2}>{key2}: {data[field][key][key2]}</p>
                                            ))
                                        }
                                    </div>
                                ))
                            ) : (
                                Object.keys(data[field]).map((key, index) => (
                                    <p key={index}>{key}: {data[field][key]}</p>
                                ))
                            )
                        ) : (
                            <p>field error...</p>
                        )
                    }
                </div>
            </div>
        );
    }

    return (
        <div id="single-car">

            {params ? (
                data ? (
                    <div className='centered-container'>
                        <h1 className='title'>{params.carId}</h1>
                        {console.log(data)}
                        {print_data(data, 'price')}
                        {print_data(data, 'battery')}
                        {print_data(data, 'charge')}
                        {print_data(data, 'performance')}
                        {print_data(data, 'date')}
                        {print_data(data, 'dimensions')}
                        {print_data(data, 'efficiency')}
                        {print_data(data, 'misscellaneous')}
                        {print_data(data, 'range')}
                        {print_data(data, 'real_efficiency')}
                        {/* {print_data(data, 'v2x')}  TODO   */} 
                    </div>
                ) : (
                    <div className='centered-container'>
                        <h1>Loading...</h1>
                    </div>
                )
            ) : (
                <div className='centered-container'>
                    <h1>Car not found</h1>
                    <Menu title="" options={[
                        { name: 'Go Back', path: '/..' },
                    ]} />
                </div>
            )}
            <Menu title="" options={[
                { name: 'Go Back', path: '/..' },
            ]} />

        </div>
    );
}